import { render, staticRenderFns } from "./TeacherEnrollmane.vue?vue&type=template&id=59b1635b"
import script from "./TeacherEnrollmane.vue?vue&type=script&lang=js"
export * from "./TeacherEnrollmane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports